__turbopack_context__.v({
  "button": "Navbar-module-scss-module__lNo5bq__button",
  "desktop": "Navbar-module-scss-module__lNo5bq__desktop",
  "drop": "Navbar-module-scss-module__lNo5bq__drop",
  "links": "Navbar-module-scss-module__lNo5bq__links",
  "mobile": "Navbar-module-scss-module__lNo5bq__mobile",
  "nav": "Navbar-module-scss-module__lNo5bq__nav",
});
